import { useEffect } from "react";

const DontExit = ({message}) => {
    useEffect(() => {
        const confirmExit = (e) =>  {
            e.returnValue = confirmExit;
            return confirmExit;
        };

        window.addEventListener("beforeunload", confirmExit);

        return () => {
            window.removeEventListener("beforeunload", confirmExit);
        }
    }, [message])

    return "";
}

export default DontExit;
